
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Package, Weight, Shield } from "lucide-react";
import { ParcelDetails } from "@/hooks/bookings/types";

interface BookingParcelOverviewCardProps {
  parcels: ParcelDetails[];
  totalParcelsCount: number | null;
}

const BookingParcelOverviewCard = ({
  parcels,
  totalParcelsCount
}: BookingParcelOverviewCardProps) => {
  const safeParcel = parcels || [];
  
  const totalWeight = safeParcel.reduce((sum, parcel) => {
    const weight = parseFloat(parcel.weight || '0');
    return sum + weight * parcel.quantity;
  }, 0);

  const totalInsuredValue = safeParcel.reduce((sum, parcel) => {
    if (parcel.insurance_enabled && parcel.value) {
      return sum + parseFloat(parcel.value) * parcel.quantity;
    }
    return sum;
  }, 0);

  const insuredParcels = safeParcel.filter(p => p.insurance_enabled).length;

  return (
    <Card className="flex-1 h-full">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Package className="h-4 w-4 text-primary" />
          Parcel Summary
          <Badge variant="default" className="ml-auto font-medium">
            {totalParcelsCount || safeParcel.length} {(totalParcelsCount || safeParcel.length) === 1 ? 'item' : 'items'}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 h-full">
          <div className="text-center p-3 rounded-lg bg-muted/50">
            <div className="flex items-center justify-center gap-1 mb-1">
              <Package className="h-3 w-3 text-muted-foreground" />
              <span className="text-xs font-medium text-muted-foreground">Total Parcels</span>
            </div>
            <div className="text-lg font-semibold">{totalParcelsCount || safeParcel.length}</div>
          </div>
          
          <div className="text-center p-3 rounded-lg bg-muted/50">
            <div className="flex items-center justify-center gap-1 mb-1">
              <Weight className="h-3 w-3 text-muted-foreground" />
              <span className="text-xs font-medium text-muted-foreground">Total Weight</span>
            </div>
            <div className="text-lg font-semibold">{totalWeight.toFixed(1)} kg</div>
          </div>
          
          <div className="text-center p-3 rounded-lg bg-muted/50">
            <div className="flex items-center justify-center gap-1 mb-1">
              <Shield className="h-3 w-3 text-muted-foreground" />
              <span className="text-xs font-medium text-muted-foreground">Insurance</span>
            </div>
            <div className="text-lg font-semibold">
              {insuredParcels > 0 ? `ZAR ${totalInsuredValue.toFixed(0)}` : 'None'}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BookingParcelOverviewCard;
